var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216.369,
    height: 278.079,
    viewBox: "0 0 57.248 73.575",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.232195
    },
    d: "m67.215 23.99 35.889 35.888L65.79 97.19l50.847.374c0-14.686.051-57.809.051-73.206-11.089 0-27.2-.369-49.474-.369z",
    transform: "translate(-65.791 -23.99)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fe9900",
      fillOpacity: 1,
      strokeWidth: 0.232195
    },
    d: "m73.565 23.99 35.889 35.888L72.14 97.19l50.847.374c0-14.686.051-57.809.051-73.206-11.089 0-27.2-.369-49.474-.369z",
    transform: "translate(-65.791 -23.99)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEnd);
export default __webpack_public_path__ + "static/media/flagEnd.dd12b0688098f7923e1a3895d7e590a0.svg";
export { ForwardRef as ReactComponent };